var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-layout',{attrs:{"row":""}},[_c('Header',{attrs:{"title":"Služby","subtitle":"Ponúkame:"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }